<template>
  <component
    :is="tag"
    class="session-avatar"
    :class="{
      'has-image': hasImage,
      'group-chat': session.type === 'group' && !hasImage
    }"
    :style="avatarStyle"
  >
    <template v-if="hasImage">
    </template>
    <template v-else-if="session.type === 'group'">
      <span class="group-node a">{{ getGroupNodes()[0] }}</span>
      <span class="group-node b">{{ getGroupNodes()[1] }}</span>
      <span class="group-node c">{{ getGroupNodes()[2] }}</span>
    </template>
    <template v-else>
      {{ getAvatarText() }}
    </template>
  </component>
</template>

<script>
import { solidFromColor } from '../utils/avatarColor'

export default {
  name: 'SessionAvatar',
  props: {
    session: { type: Object, required: true },
    tag: { type: String, default: 'div' }
  },
  computed: {
    agentStatus() {
      if (this.session.type !== 'agent' && !(this.session.hasMyAgent && this.session.myAgentStatus)) return null
      const s = this.session.myAgentStatus
      if (!s || s === 'idle') return 'idle'
      if (s === 'thinking' || s === 'executing_tool' || s === 'initializing') return 'busy'
      if (s === 'error' || s === 'init_failed') return 'busy'
      return 'idle'
    },
    hasImage() {
      return !!this.session.avatar
    },
    avatarStyle() {
      if (this.session.avatar) {
        return { background: `center / cover no-repeat url(${this.session.avatar})` }
      }
      // 无真实头像：用后端 avatarColorRgb 纯色（不前端生成色）
      const bg = solidFromColor(this.session.avatarColorRgb)
      return bg ? { background: bg } : {}
    }
  },
  methods: {
    getAvatarText() {
      return (this.session.name || '?').slice(0, 1)
    },
    getGroupNodes() {
      const name = this.session.name || ''
      return [name.slice(0, 1) || '群', '成', '员']
    }
  }
}
</script>
